/*
* Copyright (c) 2025 SGS Europe. All rights reserved.
*
* This program is the CONFIDENTIAL and PROPRIETARY property of SGS Europe.
* Any unauthorised use, reproduction, or transfer of this program is strictly
* prohibited.
*
* File Name: AnnotationData.js
*
* Description: JavaScript code for the annotation data module.
*
*/

var g_oAnnotationData = {};

(function () {
	"use strict";

	/**
	 * Create the Annotation Data object.
	 */
	function AnnotationData() {}

	/**
	 * Renders the data for an annotation.
	 * @param {int} annotationId - The id of the annotation.
	 * @param {int} annotationType - The annotation type.
	 * @param {object} annotationData - The annotation data object.
	 */
	AnnotationData.prototype.renderAnnotationData = function (annotationId, annotationType, annotationData) {

		// Build up the HTML for the annotation data.
		var oAnnotationDataHTML = "";
		
		// Create a div for closing the annotation data.
		oAnnotationDataHTML += "<div id='" + annotationId + "_annotationDataClose' class='annotationDataClose' align='right'>";
		oAnnotationDataHTML += "<input id='" + annotationId + "_closeDataData' type='image' src='img/Cancel-Close_wht_24.png' title='" + "Close Annotation Data" + "' class='closeannotationdatabutton tooltip'>";
		oAnnotationDataHTML += "</div>";

		// Loop through each of the annotation additional data entries.
		$.each(annotationData.AdditionalData, function (key, value) {
			oAnnotationDataHTML += g_oAnnotationData.renderAnnotationDataItem(key, value);
		});

		// Add the annotation data html to the container.
		$("#" + annotationId + "_annotationDataContainer").html(oAnnotationDataHTML);

		// Add the display class to the annotation data container.
		$("#" + annotationId + "_annotationDataContainer").addClass("annotationDataContainer");

		// Show the content of the annotation data container.
		$("#" + annotationId + "_annotationDataContainer").slideDown("", "", function () { g_oAnnotationData.scrollAnnotationData(annotationId); });
	};

	/**
	 * Renders an annotation data item.
	 * @param {string} key - The item key.
	 * @param {string} value - The item value.
	 */
	AnnotationData.prototype.renderAnnotationDataItem = function (key, value) {
		return "<div class='annotationData'><div style='overflow: auto; margin-top: 0px;'><b>" + key + "</b><br/>" + value + "</div></div>";
	};

	/**
	 * Closes the data for an annotation.
	 * @param {int} annotationId - The id of the annotation.
	 */
	AnnotationData.prototype.closeAnnotationData = function (annotationId, bAnimate) {

		// Determine the animation time.
		var iAnimationTime = bAnimate ? 400 : 0;

		// Close the data for the annotation, then remove the display class for the annotation data container.
		$("#" + annotationId + "_annotationDataContainer").slideUp(iAnimationTime, "", function () { $("#" + annotationId + "_annotationDataContainer").removeClass("annotationDataContainer"); });
	};

	/**
	 * Scrolls to the data for an annotation.
	 * @param {int} annotationId - The id of the annotation.
	 */
	AnnotationData.prototype.scrollAnnotationData = function (annotationId) {

		// Get the position of the annotation data container.
		var iAnnotationDataPosition = $("#" + annotationId + "_annotationDataContainer").position().top;

		// Remove 60px for the height of the divAnnDiv_Header and remove 20px of padding.
		iAnnotationDataPosition -= 60;

		// Scroll the annotation data into view.
		$("#divAnnDiv_ListItems").animate({ scrollTop: "+=" + iAnnotationDataPosition + "px" });
	};

	/**
	 * Add the AnnotationData object to the window.
	 */
	window.AnnotationData = AnnotationData;

}());